import GetWorkItemTypesRequestModelBase from '../_generated/modelBases/get-work-item-types-request-model-base';

export default class GetWorkItemTypesRequestModel extends GetWorkItemTypesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
